import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import { SurveyQuestion } from '../builders/survey_question_builder';

interface ISelectOptionFormDef {
  title: string;
  value: string | number | boolean;
  order?: number;
}

interface ISurveyQuestionFormDef {
  name: string;
  title: string;
  render_type: string;
  order?: number;
  options?: ISelectOptionFormDef[];
  placeholder?: string;
  required?: boolean;
  has_saved_value: boolean;
  initial_value?: string | number | number[];
  max_choices?: number;
  clearable?: boolean;
}

export interface ISurveyQuestionTypeFormDef {
  properties: ISurveyQuestionFormDef[];
}

export interface ISurveyQuestionTypeStrategyOption {
  buildFormInput: (question: SurveyQuestion) => ISurveyQuestionTypeFormDef;
  buildResponse: <T>(res: T) => { answer_choices: T[] } | { free_text_answer: T | string };
}

export const SurveyQuestionTypeStrategy = new Strategy<ISurveyQuestionTypeStrategyOption>({
  FREE: {
    buildFormInput: (surveyQuestion: SurveyQuestion) => {
      const properties = [
        {
          name: `question-${surveyQuestion.question.id}`,
          path: `question-${surveyQuestion.question.id}`,
          title: surveyQuestion.question.prompt,
          render_type: 'textarea',
          required: _4.get(surveyQuestion, 'question.response_required', false),
          has_saved_value: !_4.isEmpty(surveyQuestion.free_text_answer),
          initial_value: surveyQuestion.free_text_answer
        }
      ];

      return { properties };
    },
    buildResponse: <T>(response: T) => {
      return { free_text_answer: _4.isEmpty(response) ? '' : response };
    }
  },
  SINGLE: {
    buildFormInput: (surveyQuestion: SurveyQuestion) => {
      const properties = [
        {
          name: `question-${surveyQuestion.question.id}`,
          path: `question-${surveyQuestion.question.id}`,
          title: surveyQuestion.question.prompt,
          render_type: 'list',
          required: _4.get(surveyQuestion, 'question.response_required', false),
          max_choices: 1,
          has_saved_value: !_4.isEmpty(surveyQuestion.answer_choices),
          initial_value: surveyQuestion.answer_choices,
          clearable: !_4.get(surveyQuestion, 'question.response_required', false),
          options: _4.map(surveyQuestion.choices, (choice) => {
            return {
              title: choice.text,
              value: choice.id
            };
          })
        }
      ];

      return { properties };
    },
    buildResponse: <T>(response: T) => {
      return { answer_choices: _4.isNumber(response) ? [response] : [] };
    }
  },
  MULTI: {
    buildFormInput: (surveyQuestion: SurveyQuestion) => {
      const properties: ISurveyQuestionFormDef[] = [
        {
          ..._4.first(SurveyQuestionTypeStrategy.getByKey('SINGLE').buildFormInput(surveyQuestion).properties),
          max_choices: _4.size(surveyQuestion.choices),
          clearable: !_4.get(surveyQuestion, 'question.response_required', false),
          required: _4.get(surveyQuestion, 'question.response_required', false),
          has_saved_value: !_4.isEmpty(surveyQuestion.answer_choices),
          initial_value: surveyQuestion.answer_choices
        }
      ];

      return { properties };
    },
    buildResponse: <T>(response: T) => {
      if (_4.isString(response) || _4.isNumber(response)) {
        return { answer_choices: [Number(response)] as any };
      }
      return { answer_choices: response };
    }
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/strategies/survey_question_type_strategy.ts